import { createContext } from "react";
import useAgentProjectSummaries from "../hooks/data/useAgentProjectSummaries";

export interface IProjectAgentLocationSummariesContext extends ReturnType<typeof useAgentProjectSummaries> {

};

const ProjectAgentLocationSummariesContext = createContext<IProjectAgentLocationSummariesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ProjectAgentLocationSummariesContext